import { createContext } from 'react';

// Visual scope only. React portals inherit this without affecting other workspaces.
export const CustomerThemeContext = createContext(false);